<template>
    <b-modal class="dialog" :active="isActive" has-modal-card>
        <div class="modal-card">
            <section class="modal-card-body is-titleless">
                <textarea class="input mt-10"
                          v-model="note"
                          ref="noteInput"
                          :placeholder="placeholder">
                </textarea>
            </section>
            <footer class="modal-card-foot">
                <button class="button is-primary" @click="submit">OK</button>
                <button class="button is-danger" type="button" @click="cancel">
                    {{ $t('interface.cancel') }}
                </button>
            </footer>
        </div>
    </b-modal>
</template>

<script>
    export default {
        data() {
          return {
              note: '',
              isActive: false,
              placeholder: '',
              onConfirm: false,
              onCancel: false
          }
        },
        methods: {
            refresh() {
                this.note = ''
                this.onConfirm = false
                this.onCancel = false
                this.placeholder = this.$t('interface.inputNote')
            },
            open({placeholder, onConfirm, onCancel}) {
                this.onConfirm = onConfirm || false
                this.onCancel = onCancel || false
                this.placeholder = placeholder || this.$t('interface.inputNote')
                this.isActive = true
            },
            submit() {
                this.$emit('confirm', this.note)
                if(this.onConfirm) this.onConfirm(this.note)
                this.isActive = false
                this.refresh()
            },
            cancel() {
                this.$emit('cancel')
                if(this.onCancel) this.onCancel()
                this.isActive = false
                this.refresh()
            }
        },
        mounted() {
            this.refresh()
        },
        watch: {
            isActive(state) {
                if (state) this.$nextTick(() => this.$refs.noteInput.focus())
            }
        }
    }
</script>

<style lang="scss" scoped>
    .modal-card {
        width: auto;
    }

    .input {
        height: 100px;
    }
</style>
